import { Fragment, ReactNode } from 'react';

export default function Scoreboard<G extends { id: string | number }>({
  games,
  children,
  className,
  injectAtIndex,
  injectedClassName
}: {
  games: G[];
  children: (game: G) => ReactNode;
  className: string;
  injectAtIndex?: (index: number) => ReactNode;
  injectedClassName?: string;
}) {
  return (
    <div className={className}>
      {games.map((game, index) => {
        const injected = injectAtIndex && injectAtIndex(index);

        return (
          <Fragment key={game.id}>
            {injected && <div className={injectedClassName}>{injected}</div>}
            {children(game)}
          </Fragment>
        );
      })}
      {games.length === 0 && injectAtIndex && <div className={injectedClassName}>{injectAtIndex(-1)}</div>}
    </div>
  );
}
